import { APICore } from "./apiCore";

const api = new APICore();
const baseUrl = "/supplier-api/notification";

// The latest 50 (newest first): the bell shows 10, so it never needs them all.
function all() {
  return api.get(`${baseUrl}`, { limit: 50 });
}

// Bulk mark all as read
function markAllRead() {
  return api.create(`${baseUrl}/read`, {});
}

// Single notification mark as read
function markRead(id: number | string) {
  return api.update(`${baseUrl}/${id}/read`, {});
}
/*
function getOne(id: number) {
  return api.get(`${baseUrl}/${id}`, {});
}

function create(params: IAllergenItemCreateRequest) {
  return api.create(`${baseUrl}`, params);
}

function update(id: number, params: IAllergenItemUpdateRequest) {
  return api.update(`${baseUrl}/${id}`, params);
}

function deleteItem(id: number) {
  return api.delete(`${baseUrl}/${id}`);
}*/

export { all, markAllRead, markRead };
